import { Breadcrumbs, Center, Divider, Group, Stack, Text, ThemeIcon, Title } from "@mantine/core"
import { useNavigate } from "react-router-dom"
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome"
import { faChartArea, faGear } from "@fortawesome/free-solid-svg-icons"

import { Content } from "./ConfigureContent"


export const TronDashboardConfigure = () => {

    const navigate = useNavigate()

    return (
        <div className="flow-vertical fill-parent" style={{gap: 15}} >
            <Stack spacing={4}>
                <Group align="flex-end">
                    <Group mr={20} spacing={4}>
                        <ThemeIcon color="gray">
                            <FontAwesomeIcon icon={faGear} />
                        </ThemeIcon>
                        <Title order={2}>Tron</Title>
                    </Group>
                    <Breadcrumbs mb={4} separator="/">
                        <Text size="sm" variant="link" component="a" onClick={() => navigate("../.."+window.location.search)}>Dashboards</Text>
                        <Text size="sm" variant="link" component="a" onClick={() => navigate(".."+window.location.search)}>Tron</Text>
                        <Text size="sm" color="dimmed">Configure</Text>
                    </Breadcrumbs>
                </Group>
                <Divider />
            </Stack>
            <Content />
        </div>
    )
}

export default TronDashboardConfigure